module.exports = __webpack_public_path__ + "static/media/trucking.d7f72d4f.png";